/* eslint-disable @typescript-eslint/no-explicit-any */
export interface GeofenceModel {
  name: string;
  type: string;
}
